//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuditClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAuditEvents(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAuditEventDto> {
        let url_ = this.baseUrl + "/api/v1/audit?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditEvents(_response);
        });
    }

    protected processGetAuditEvents(response: Response): Promise<PaginatedListOfAuditEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAuditEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAuditEventDto>(null as any);
    }

    getAuditEvent(auditEventId: number, signal?: AbortSignal): Promise<AuditEventDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/audit/{auditEventId}";
        if (auditEventId === undefined || auditEventId === null)
            throw new globalThis.Error("The parameter 'auditEventId' must be defined.");
        url_ = url_.replace("{auditEventId}", encodeURIComponent("" + auditEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditEvent(_response);
        });
    }

    protected processGetAuditEvent(response: Response): Promise<AuditEventDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditEventDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditEventDetailsDto>(null as any);
    }
}

export class AuthLogsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAuthLogs(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, userId?: string | null | undefined, isSuccess?: boolean | null | undefined, clientIds?: string[] | null | undefined, flowTypes?: AuthFlowType[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAuthLogDto> {
        let url_ = this.baseUrl + "/api/v1/auth-logs?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isSuccess !== undefined && isSuccess !== null)
            url_ += "isSuccess=" + encodeURIComponent("" + isSuccess) + "&";
        if (clientIds !== undefined && clientIds !== null)
            clientIds && clientIds.forEach(item => { url_ += "clientIds=" + encodeURIComponent("" + item) + "&"; });
        if (flowTypes !== undefined && flowTypes !== null)
            flowTypes && flowTypes.forEach(item => { url_ += "flowTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthLogs(_response);
        });
    }

    protected processGetAuthLogs(response: Response): Promise<PaginatedListOfAuthLogDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAuthLogDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAuthLogDto>(null as any);
    }

    getFilterOptions(signal?: AbortSignal): Promise<AuthLogFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/v1/auth-logs/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilterOptions(_response);
        });
    }

    protected processGetFilterOptions(response: Response): Promise<AuthLogFilterOptionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthLogFilterOptionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthLogFilterOptionsDto>(null as any);
    }
}

export class CurrentUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentUser(signal?: AbortSignal): Promise<UserDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsDto>(null as any);
    }

    updateCurrentUser(command: UpdateCurrentUserCommand, signal?: AbortSignal): Promise<UserDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/current-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCurrentUser(_response);
        });
    }

    protected processUpdateCurrentUser(response: Response): Promise<UserDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsDto>(null as any);
    }

    getCurrentUserTenants(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantDto> {
        let url_ = this.baseUrl + "/api/v1/current-user/tenants?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUserTenants(_response);
        });
    }

    protected processGetCurrentUserTenants(response: Response): Promise<PaginatedListOfTenantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantDto>(null as any);
    }

    getCurrentUserStudies(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantStudyDto> {
        let url_ = this.baseUrl + "/api/v1/current-user/studies?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUserStudies(_response);
        });
    }

    protected processGetCurrentUserStudies(response: Response): Promise<PaginatedListOfTenantStudyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantStudyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantStudyDto>(null as any);
    }

    getCurrentUserQuestionnaires(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantQuestionnaireDto> {
        let url_ = this.baseUrl + "/api/v1/current-user/questionnaires?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUserQuestionnaires(_response);
        });
    }

    protected processGetCurrentUserQuestionnaires(response: Response): Promise<PaginatedListOfTenantQuestionnaireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantQuestionnaireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantQuestionnaireDto>(null as any);
    }

    updateCurrentUserPassword(command: UpdateCurrentUserPasswordCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/current-user/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCurrentUserPassword(_response);
        });
    }

    protected processUpdateCurrentUserPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LanguagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLanguages(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfLanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<PaginatedListOfLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfLanguageDto>(null as any);
    }
}

export class ManagementClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getGatewayDeploymentInformation(signal?: AbortSignal): Promise<DeploymentInformation> {
        let url_ = this.baseUrl + "/api/v1/management/gateway/information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGatewayDeploymentInformation(_response);
        });
    }

    protected processGetGatewayDeploymentInformation(response: Response): Promise<DeploymentInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentInformation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeploymentInformation>(null as any);
    }

    getTenantsWithDeploymentInformation(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantWithDeploymentInformationDto> {
        let url_ = this.baseUrl + "/api/v1/management/tenants/information?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantsWithDeploymentInformation(_response);
        });
    }

    protected processGetTenantsWithDeploymentInformation(response: Response): Promise<PaginatedListOfTenantWithDeploymentInformationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantWithDeploymentInformationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantWithDeploymentInformationDto>(null as any);
    }

    getTenantConfiguration(slug: string, signal?: AbortSignal): Promise<TenantConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/management/tenants/{slug}/configuration";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantConfiguration(_response);
        });
    }

    protected processGetTenantConfiguration(response: Response): Promise<TenantConfigurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantConfigurationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantConfigurationDto>(null as any);
    }

    getTenantImageTags(limit?: number | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/management/tenants/image-tags?";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantImageTags(_response);
        });
    }

    protected processGetTenantImageTags(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getTenantBackendImageTags(limit?: number | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/management/tenants/backend-image-tags?";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantBackendImageTags(_response);
        });
    }

    protected processGetTenantBackendImageTags(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    updateGatewayVersion(command: UpdateGatewayVersionCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/management/gateway/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGatewayVersion(_response);
        });
    }

    protected processUpdateGatewayVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateGatewayBackendVersion(command: UpdateGatewayBackendVersionCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/management/gateway-backend/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGatewayBackendVersion(_response);
        });
    }

    protected processUpdateGatewayBackendVersion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTenantVersions(command: UpdateTenantVersionsCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/management/tenants/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTenantVersions(_response);
        });
    }

    protected processUpdateTenantVersions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setTenantImageTag(command: SetTenantImageTagCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/management/tenants/image-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTenantImageTag(_response);
        });
    }

    protected processSetTenantImageTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setTenantBackendImageTag(command: SetTenantBackendImageTagCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/management/tenants/backend-image-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTenantBackendImageTag(_response);
        });
    }

    protected processSetTenantBackendImageTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MessagingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getEmailTemplates(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfEmailTemplateDto> {
        let url_ = this.baseUrl + "/api/v1/messaging/emails/templates?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailTemplates(_response);
        });
    }

    protected processGetEmailTemplates(response: Response): Promise<PaginatedListOfEmailTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfEmailTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfEmailTemplateDto>(null as any);
    }

    createEmailTemplate(command: CreateEmailTemplateCommand, signal?: AbortSignal): Promise<EmailTemplateDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/messaging/emails/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateEmailTemplate(_response);
        });
    }

    protected processCreateEmailTemplate(response: Response): Promise<EmailTemplateDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailTemplateDetailsDto>(null as any);
    }

    getEmailTemplate(emailTemplateId: string, signal?: AbortSignal): Promise<EmailTemplateDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/messaging/emails/templates/{emailTemplateId}";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new globalThis.Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailTemplate(_response);
        });
    }

    protected processGetEmailTemplate(response: Response): Promise<EmailTemplateDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailTemplateDetailsDto>(null as any);
    }

    updateEmailTemplate(emailTemplateId: string, command: UpdateEmailTemplateCommand, signal?: AbortSignal): Promise<EmailTemplateDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/messaging/emails/templates/{emailTemplateId}";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new globalThis.Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmailTemplate(_response);
        });
    }

    protected processUpdateEmailTemplate(response: Response): Promise<EmailTemplateDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailTemplateDetailsDto>(null as any);
    }

    deleteEmailTemplate(emailTemplateId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/messaging/emails/templates/{emailTemplateId}";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new globalThis.Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEmailTemplate(_response);
        });
    }

    protected processDeleteEmailTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    sendMessageToUsers(command: SendMessageCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/messaging/users/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMessageToUsers(_response);
        });
    }

    protected processSendMessageToUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    getMessageLogEntries(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, channelTypes?: ChannelType[] | null | undefined, statuses?: MessageStatus[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfMessageLogEntryDto> {
        let url_ = this.baseUrl + "/api/v1/messaging/logs?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (channelTypes !== undefined && channelTypes !== null)
            channelTypes && channelTypes.forEach(item => { url_ += "channelTypes=" + encodeURIComponent("" + item) + "&"; });
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessageLogEntries(_response);
        });
    }

    protected processGetMessageLogEntries(response: Response): Promise<PaginatedListOfMessageLogEntryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfMessageLogEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfMessageLogEntryDto>(null as any);
    }

    getMessageLogFilterOptions(signal?: AbortSignal): Promise<MessageLogFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/v1/messaging/logs/filter-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessageLogFilterOptions(_response);
        });
    }

    protected processGetMessageLogFilterOptions(response: Response): Promise<MessageLogFilterOptionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageLogFilterOptionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageLogFilterOptionsDto>(null as any);
    }

    getMessageLogEntry(messageLogEntryId: string, signal?: AbortSignal): Promise<MessageLogEntryDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/messaging/logs/{messageLogEntryId}";
        if (messageLogEntryId === undefined || messageLogEntryId === null)
            throw new globalThis.Error("The parameter 'messageLogEntryId' must be defined.");
        url_ = url_.replace("{messageLogEntryId}", encodeURIComponent("" + messageLogEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessageLogEntry(_response);
        });
    }

    protected processGetMessageLogEntry(response: Response): Promise<MessageLogEntryDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageLogEntryDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageLogEntryDetailsDto>(null as any);
    }
}

export class OidcApplicationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getOidcApplications(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfOidcApplicationDto> {
        let url_ = this.baseUrl + "/api/v1/oidc-applications?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOidcApplications(_response);
        });
    }

    protected processGetOidcApplications(response: Response): Promise<PaginatedListOfOidcApplicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfOidcApplicationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfOidcApplicationDto>(null as any);
    }

    createOidcApplication(command: CreateOidcApplicationCommand, signal?: AbortSignal): Promise<OidcApplicationDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/oidc-applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOidcApplication(_response);
        });
    }

    protected processCreateOidcApplication(response: Response): Promise<OidcApplicationDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OidcApplicationDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OidcApplicationDetailsDto>(null as any);
    }

    getOidcApplication(clientId: string, signal?: AbortSignal): Promise<OidcApplicationDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/oidc-applications/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOidcApplication(_response);
        });
    }

    protected processGetOidcApplication(response: Response): Promise<OidcApplicationDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OidcApplicationDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OidcApplicationDetailsDto>(null as any);
    }

    updateOidcApplication(clientId: string, command: UpdateOidcApplicationCommand, signal?: AbortSignal): Promise<OidcApplicationDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/oidc-applications/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOidcApplication(_response);
        });
    }

    protected processUpdateOidcApplication(response: Response): Promise<OidcApplicationDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OidcApplicationDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OidcApplicationDetailsDto>(null as any);
    }

    deleteOidcApplication(clientId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/oidc-applications/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOidcApplication(_response);
        });
    }

    protected processDeleteOidcApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StatisticsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDashboardStatistics(signal?: AbortSignal): Promise<DashboardStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDashboardStatistics(_response);
        });
    }

    protected processGetDashboardStatistics(response: Response): Promise<DashboardStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardStatisticsDto>(null as any);
    }
}

export class TenantsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTenants(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantDto> {
        let url_ = this.baseUrl + "/api/v1/tenants?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: Response): Promise<PaginatedListOfTenantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantDto>(null as any);
    }

    createTenant(command: CreateTenantCommand, signal?: AbortSignal): Promise<TenantDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: Response): Promise<TenantDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDetailsDto>(null as any);
    }

    getTenant(tenantId: string, signal?: AbortSignal): Promise<TenantDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/tenants/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenant(_response);
        });
    }

    protected processGetTenant(response: Response): Promise<TenantDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDetailsDto>(null as any);
    }

    updateTenant(tenantId: string, command: UpdateTenantCommand, signal?: AbortSignal): Promise<TenantDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/tenants/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTenant(_response);
        });
    }

    protected processUpdateTenant(response: Response): Promise<TenantDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDetailsDto>(null as any);
    }

    deleteTenant(tenantId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenants/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTenant(_response);
        });
    }

    protected processDeleteTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    rollbackTenant(tenantId: string, command: RollbackTenantCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenants/{tenantId}/rollback";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRollbackTenant(_response);
        });
    }

    protected processRollbackTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUsers(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfUserDto> {
        let url_ = this.baseUrl + "/api/v1/users?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<PaginatedListOfUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfUserDto>(null as any);
    }

    createUser(command: CreateUserCommand, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    enrichUser(userId: string, signal?: AbortSignal): Promise<UserDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/enrich";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnrichUser(_response);
        });
    }

    protected processEnrichUser(response: Response): Promise<UserDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsDto>(null as any);
    }

    enrichUsers(userIds: string[], signal?: AbortSignal): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/v1/users/enrich";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnrichUsers(_response);
        });
    }

    protected processEnrichUsers(response: Response): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    getUser(userId: string, signal?: AbortSignal): Promise<UserDetailsWithTenantsDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserDetailsWithTenantsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsWithTenantsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsWithTenantsDto>(null as any);
    }

    updateUser(userId: string, command: UpdateUserCommand, signal?: AbortSignal): Promise<UserDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsDto>(null as any);
    }

    deleteUser(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendRegistrationMail(userId: string, fallbackLanguageCode?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/registrationmail?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (fallbackLanguageCode !== undefined && fallbackLanguageCode !== null)
            url_ += "fallbackLanguageCode=" + encodeURIComponent("" + fallbackLanguageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRegistrationMail(_response);
        });
    }

    protected processSendRegistrationMail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateUserPassword(userId: string, command: UpdateUserPasswordCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/password";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserPassword(_response);
        });
    }

    protected processUpdateUserPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateUserAccountStatus(userId: string, command: UpdateUserAccountStatusCommand, signal?: AbortSignal): Promise<UserDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/account-status";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserAccountStatus(_response);
        });
    }

    protected processUpdateUserAccountStatus(response: Response): Promise<UserDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsDto>(null as any);
    }
}

export class PaginatedListOfAuditEventDto implements IPaginatedListOfAuditEventDto {
    items!: AuditEventDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditEventDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAuditEventDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAuditEventDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAuditEventDto {
    items: AuditEventDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class AuditEventDto implements IAuditEventDto {
    id!: number;
    created!: Date;
    lastModified!: Date;
    type!: string;
    responseStatusCode?: number | undefined;
    userId?: string | undefined;
    user?: UserDto | undefined;

    constructor(data?: IAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.type = _data["type"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): AuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["type"] = this.type;
        data["responseStatusCode"] = this.responseStatusCode;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }

    clone(): AuditEventDto {
        const json = this.toJSON();
        let result = new AuditEventDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDto {
    id: number;
    created: Date;
    lastModified: Date;
    type: string;
    responseStatusCode?: number | undefined;
    userId?: string | undefined;
    user?: UserDto | undefined;
}

export class UserDto implements IUserDto {
    id!: string;
    userName?: string | undefined;
    email?: string | undefined;
    emailConfirmed!: boolean;
    givenName?: string | undefined;
    familyName?: string | undefined;
    lastSuccessfulLogin?: Date | undefined;
    lastFailedLogin?: Date | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.givenName = _data["givenName"];
            this.familyName = _data["familyName"];
            this.lastSuccessfulLogin = _data["lastSuccessfulLogin"] ? new Date(_data["lastSuccessfulLogin"].toString()) : undefined as any;
            this.lastFailedLogin = _data["lastFailedLogin"] ? new Date(_data["lastFailedLogin"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["givenName"] = this.givenName;
        data["familyName"] = this.familyName;
        data["lastSuccessfulLogin"] = this.lastSuccessfulLogin ? this.lastSuccessfulLogin.toISOString() : undefined as any;
        data["lastFailedLogin"] = this.lastFailedLogin ? this.lastFailedLogin.toISOString() : undefined as any;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: string;
    userName?: string | undefined;
    email?: string | undefined;
    emailConfirmed: boolean;
    givenName?: string | undefined;
    familyName?: string | undefined;
    lastSuccessfulLogin?: Date | undefined;
    lastFailedLogin?: Date | undefined;
}

export class SortingParameter implements ISortingParameter {
    property!: string;
    direction!: SortDirection;

    constructor(data?: ISortingParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): SortingParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SortingParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["direction"] = this.direction;
        return data;
    }

    clone(): SortingParameter {
        const json = this.toJSON();
        let result = new SortingParameter();
        result.init(json);
        return result;
    }
}

export interface ISortingParameter {
    property: string;
    direction: SortDirection;
}

export enum SortDirection {
    Ascending = "ascending",
    Descending = "descending",
}

export class AuditEventDetailsDto implements IAuditEventDetailsDto {
    id!: number;
    created!: Date;
    lastModified!: Date;
    type!: string;
    userId?: string | undefined;
    userName?: string | undefined;
    data!: AuditEventDataDto;

    constructor(data?: IAuditEventDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.data = new AuditEventDataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.data = _data["data"] ? AuditEventDataDto.fromJS(_data["data"]) : new AuditEventDataDto();
        }
    }

    static fromJS(data: any): AuditEventDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }

    clone(): AuditEventDetailsDto {
        const json = this.toJSON();
        let result = new AuditEventDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDetailsDto {
    id: number;
    created: Date;
    lastModified: Date;
    type: string;
    userId?: string | undefined;
    userName?: string | undefined;
    data: AuditEventDataDto;
}

export class AuditEventDataDto implements IAuditEventDataDto {
    action!: AuditEventActionDto;
    userId?: string | undefined;
    endDate!: Date;
    duration!: number;
    eventType!: string;
    startDate!: Date;
    environment!: AuditEventEnvironmentDto;

    constructor(data?: IAuditEventDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.action = new AuditEventActionDto();
            this.environment = new AuditEventEnvironmentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] ? AuditEventActionDto.fromJS(_data["action"]) : new AuditEventActionDto();
            this.userId = _data["userId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.eventType = _data["eventType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.environment = _data["environment"] ? AuditEventEnvironmentDto.fromJS(_data["environment"]) : new AuditEventEnvironmentDto();
        }
    }

    static fromJS(data: any): AuditEventDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action ? this.action.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["eventType"] = this.eventType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["environment"] = this.environment ? this.environment.toJSON() : undefined as any;
        return data;
    }

    clone(): AuditEventDataDto {
        const json = this.toJSON();
        let result = new AuditEventDataDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDataDto {
    action: AuditEventActionDto;
    userId?: string | undefined;
    endDate: Date;
    duration: number;
    eventType: string;
    startDate: Date;
    environment: AuditEventEnvironmentDto;
}

export class AuditEventActionDto implements IAuditEventActionDto {
    traceId!: string;
    userName?: string | undefined;
    ipAddress!: string;
    actionName!: string;
    httpMethod!: string;
    requestUrl!: string;
    controllerName!: string;
    responseStatus!: string;
    actionParameters?: any | undefined;
    responseStatusCode?: number | undefined;
    formVariables?: any | undefined;
    exception?: string | undefined;

    constructor(data?: IAuditEventActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.traceId = _data["traceId"];
            this.userName = _data["userName"];
            this.ipAddress = _data["ipAddress"];
            this.actionName = _data["actionName"];
            this.httpMethod = _data["httpMethod"];
            this.requestUrl = _data["requestUrl"];
            this.controllerName = _data["controllerName"];
            this.responseStatus = _data["responseStatus"];
            this.actionParameters = _data["actionParameters"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.formVariables = _data["formVariables"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): AuditEventActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["traceId"] = this.traceId;
        data["userName"] = this.userName;
        data["ipAddress"] = this.ipAddress;
        data["actionName"] = this.actionName;
        data["httpMethod"] = this.httpMethod;
        data["requestUrl"] = this.requestUrl;
        data["controllerName"] = this.controllerName;
        data["responseStatus"] = this.responseStatus;
        data["actionParameters"] = this.actionParameters;
        data["responseStatusCode"] = this.responseStatusCode;
        data["formVariables"] = this.formVariables;
        data["exception"] = this.exception;
        return data;
    }

    clone(): AuditEventActionDto {
        const json = this.toJSON();
        let result = new AuditEventActionDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventActionDto {
    traceId: string;
    userName?: string | undefined;
    ipAddress: string;
    actionName: string;
    httpMethod: string;
    requestUrl: string;
    controllerName: string;
    responseStatus: string;
    actionParameters?: any | undefined;
    responseStatusCode?: number | undefined;
    formVariables?: any | undefined;
    exception?: string | undefined;
}

export class AuditEventEnvironmentDto implements IAuditEventEnvironmentDto {
    culture!: string;
    userName?: string | undefined;
    domainName!: string;
    machineName!: string;
    assemblyName!: string;
    callingMethodName!: string;

    constructor(data?: IAuditEventEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.culture = _data["culture"];
            this.userName = _data["userName"];
            this.domainName = _data["domainName"];
            this.machineName = _data["machineName"];
            this.assemblyName = _data["assemblyName"];
            this.callingMethodName = _data["callingMethodName"];
        }
    }

    static fromJS(data: any): AuditEventEnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventEnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["userName"] = this.userName;
        data["domainName"] = this.domainName;
        data["machineName"] = this.machineName;
        data["assemblyName"] = this.assemblyName;
        data["callingMethodName"] = this.callingMethodName;
        return data;
    }

    clone(): AuditEventEnvironmentDto {
        const json = this.toJSON();
        let result = new AuditEventEnvironmentDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventEnvironmentDto {
    culture: string;
    userName?: string | undefined;
    domainName: string;
    machineName: string;
    assemblyName: string;
    callingMethodName: string;
}

export class PaginatedListOfAuthLogDto implements IPaginatedListOfAuthLogDto {
    items!: AuthLogDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAuthLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuthLogDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAuthLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAuthLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAuthLogDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAuthLogDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAuthLogDto {
    items: AuthLogDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class AuthLogDto implements IAuthLogDto {
    id!: number;
    userId?: string | undefined;
    clientId?: string | undefined;
    authFlowType!: AuthFlowType;
    externalProvider?: string | undefined;
    isSuccess!: boolean;
    failureReason!: AuthFailureReason;
    ipAddress!: string;
    userAgent?: string | undefined;
    timestamp!: Date;
    username?: string | undefined;

    constructor(data?: IAuthLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.authFlowType = _data["authFlowType"];
            this.externalProvider = _data["externalProvider"];
            this.isSuccess = _data["isSuccess"];
            this.failureReason = _data["failureReason"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): AuthLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["authFlowType"] = this.authFlowType;
        data["externalProvider"] = this.externalProvider;
        data["isSuccess"] = this.isSuccess;
        data["failureReason"] = this.failureReason;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["username"] = this.username;
        return data;
    }

    clone(): AuthLogDto {
        const json = this.toJSON();
        let result = new AuthLogDto();
        result.init(json);
        return result;
    }
}

export interface IAuthLogDto {
    id: number;
    userId?: string | undefined;
    clientId?: string | undefined;
    authFlowType: AuthFlowType;
    externalProvider?: string | undefined;
    isSuccess: boolean;
    failureReason: AuthFailureReason;
    ipAddress: string;
    userAgent?: string | undefined;
    timestamp: Date;
    username?: string | undefined;
}

export enum AuthFlowType {
    Password = "password",
    AuthorizationCode = "authorizationCode",
    RefreshToken = "refreshToken",
    ClientCredentials = "clientCredentials",
    External = "external",
    FormLogin = "formLogin",
}

export enum AuthFailureReason {
    None = "none",
    UserNotFound = "userNotFound",
    InvalidPassword = "invalidPassword",
    AccountLockedOut = "accountLockedOut",
    AccountNotAllowed = "accountNotAllowed",
    RequiresTwoFactor = "requiresTwoFactor",
    TokenInvalid = "tokenInvalid",
    UserNotAllowedToSignIn = "userNotAllowedToSignIn",
    ExternalProviderError = "externalProviderError",
    ExternalLoginInfoError = "externalLoginInfoError",
}

export class AuthLogFilterOptionsDto implements IAuthLogFilterOptionsDto {
    clientIds!: string[];
    flowTypes!: AuthFlowType[];

    constructor(data?: IAuthLogFilterOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.clientIds = [];
            this.flowTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientIds"])) {
                this.clientIds = [] as any;
                for (let item of _data["clientIds"])
                    this.clientIds!.push(item);
            }
            if (Array.isArray(_data["flowTypes"])) {
                this.flowTypes = [] as any;
                for (let item of _data["flowTypes"])
                    this.flowTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthLogFilterOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLogFilterOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientIds)) {
            data["clientIds"] = [];
            for (let item of this.clientIds)
                data["clientIds"].push(item);
        }
        if (Array.isArray(this.flowTypes)) {
            data["flowTypes"] = [];
            for (let item of this.flowTypes)
                data["flowTypes"].push(item);
        }
        return data;
    }

    clone(): AuthLogFilterOptionsDto {
        const json = this.toJSON();
        let result = new AuthLogFilterOptionsDto();
        result.init(json);
        return result;
    }
}

export interface IAuthLogFilterOptionsDto {
    clientIds: string[];
    flowTypes: AuthFlowType[];
}

export class UserDetailsDto implements IUserDetailsDto {
    id!: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    honorificPrefix?: string | undefined;
    givenName?: string | undefined;
    additionalName?: string | undefined;
    familyName?: string | undefined;
    honorificSuffix?: string | undefined;
    streetAddress?: string | undefined;
    addressLevel1?: string | undefined;
    addressLevel2?: string | undefined;
    addressLevel3?: string | undefined;
    addressLevel4?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    language?: string | undefined;
    birthDay?: Date | undefined;
    sex?: string | undefined;
    emailConfirmed!: boolean;
    phoneNumberConfirmed!: boolean;
    twoFactorEnabled!: boolean;
    lockoutEnd?: Date | undefined;
    accessFailedCount!: number;
    lastSuccessfulLogin?: Date | undefined;
    lastFailedLogin?: Date | undefined;
    lastLoginIpAddress?: string | undefined;
    roles!: RoleDto[];

    constructor(data?: IUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.honorificPrefix = _data["honorificPrefix"];
            this.givenName = _data["givenName"];
            this.additionalName = _data["additionalName"];
            this.familyName = _data["familyName"];
            this.honorificSuffix = _data["honorificSuffix"];
            this.streetAddress = _data["streetAddress"];
            this.addressLevel1 = _data["addressLevel1"];
            this.addressLevel2 = _data["addressLevel2"];
            this.addressLevel3 = _data["addressLevel3"];
            this.addressLevel4 = _data["addressLevel4"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.language = _data["language"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.sex = _data["sex"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined as any;
            this.accessFailedCount = _data["accessFailedCount"];
            this.lastSuccessfulLogin = _data["lastSuccessfulLogin"] ? new Date(_data["lastSuccessfulLogin"].toString()) : undefined as any;
            this.lastFailedLogin = _data["lastFailedLogin"] ? new Date(_data["lastFailedLogin"].toString()) : undefined as any;
            this.lastLoginIpAddress = _data["lastLoginIpAddress"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["honorificPrefix"] = this.honorificPrefix;
        data["givenName"] = this.givenName;
        data["additionalName"] = this.additionalName;
        data["familyName"] = this.familyName;
        data["honorificSuffix"] = this.honorificSuffix;
        data["streetAddress"] = this.streetAddress;
        data["addressLevel1"] = this.addressLevel1;
        data["addressLevel2"] = this.addressLevel2;
        data["addressLevel3"] = this.addressLevel3;
        data["addressLevel4"] = this.addressLevel4;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["language"] = this.language;
        data["birthDay"] = this.birthDay ? formatDate(this.birthDay) : undefined as any;
        data["sex"] = this.sex;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined as any;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lastSuccessfulLogin"] = this.lastSuccessfulLogin ? this.lastSuccessfulLogin.toISOString() : undefined as any;
        data["lastFailedLogin"] = this.lastFailedLogin ? this.lastFailedLogin.toISOString() : undefined as any;
        data["lastLoginIpAddress"] = this.lastLoginIpAddress;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UserDetailsDto {
        const json = this.toJSON();
        let result = new UserDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IUserDetailsDto {
    id: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    honorificPrefix?: string | undefined;
    givenName?: string | undefined;
    additionalName?: string | undefined;
    familyName?: string | undefined;
    honorificSuffix?: string | undefined;
    streetAddress?: string | undefined;
    addressLevel1?: string | undefined;
    addressLevel2?: string | undefined;
    addressLevel3?: string | undefined;
    addressLevel4?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    language?: string | undefined;
    birthDay?: Date | undefined;
    sex?: string | undefined;
    emailConfirmed: boolean;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd?: Date | undefined;
    accessFailedCount: number;
    lastSuccessfulLogin?: Date | undefined;
    lastFailedLogin?: Date | undefined;
    lastLoginIpAddress?: string | undefined;
    roles: RoleDto[];
}

export class RoleDto implements IRoleDto {
    id!: string;
    name!: string;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: string;
    name: string;
}

export class PaginatedListOfTenantDto implements IPaginatedListOfTenantDto {
    items!: TenantDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantDto {
    items: TenantDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantDto implements ITenantDto {
    id!: string;
    name!: string;
    slug!: string;
    apiUrl!: string;
    backendUrl!: string;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.apiUrl = _data["apiUrl"];
            this.backendUrl = _data["backendUrl"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["apiUrl"] = this.apiUrl;
        data["backendUrl"] = this.backendUrl;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: string;
    name: string;
    slug: string;
    apiUrl: string;
    backendUrl: string;
}

export class PaginatedListOfTenantStudyDto implements IPaginatedListOfTenantStudyDto {
    items!: TenantStudyDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantStudyDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantStudyDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantStudyDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantStudyDto {
    items: TenantStudyDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantStudyDto implements ITenantStudyDto {
    tenant!: TenantDto;
    study!: StudyDto;

    constructor(data?: ITenantStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tenant = new TenantDto();
            this.study = new StudyDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : new TenantDto();
            this.study = _data["study"] ? StudyDto.fromJS(_data["study"]) : new StudyDto();
        }
    }

    static fromJS(data: any): TenantStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["study"] = this.study ? this.study.toJSON() : undefined as any;
        return data;
    }

    clone(): TenantStudyDto {
        const json = this.toJSON();
        let result = new TenantStudyDto();
        result.init(json);
        return result;
    }
}

export interface ITenantStudyDto {
    tenant: TenantDto;
    study: StudyDto;
}

export class TenantEntityDto implements ITenantEntityDto {
    id!: string;
    tenantId!: string;

    constructor(data?: ITenantEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TenantEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): TenantEntityDto {
        const json = this.toJSON();
        let result = new TenantEntityDto();
        result.init(json);
        return result;
    }
}

export interface ITenantEntityDto {
    id: string;
    tenantId: string;
}

export abstract class ProjectDto extends TenantEntityDto implements IProjectDto {
    name!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    asset?: AssetDto | undefined;
    published?: Date | undefined;
    visibility!: ProjectVisibility;
    languages!: TenantLanguageDto[];

    constructor(data?: IProjectDto) {
        super(data);
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.languages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.visibility = _data["visibility"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(TenantLanguageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ProjectDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined as any;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["visibility"] = this.visibility;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ProjectDto {
        throw new Error("The abstract class 'ProjectDto' cannot be instantiated.");
    }
}

export interface IProjectDto extends ITenantEntityDto {
    name: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    asset?: AssetDto | undefined;
    published?: Date | undefined;
    visibility: ProjectVisibility;
    languages: TenantLanguageDto[];
}

export class StudyDto extends ProjectDto implements IStudyDto {

    constructor(data?: IStudyDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StudyDto {
        const json = this.toJSON();
        let result = new StudyDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDto extends IProjectDto {
}

export class InternationalizedString implements IInternationalizedString {
    translations!: { [key: string]: string; };

    constructor(data?: IInternationalizedString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (this.translations as any)![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): InternationalizedString {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizedString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (data["translations"] as any)[key] = (this.translations as any)[key];
            }
        }
        return data;
    }

    clone(): InternationalizedString {
        const json = this.toJSON();
        let result = new InternationalizedString();
        result.init(json);
        return result;
    }
}

export interface IInternationalizedString {
    translations: { [key: string]: string; };
}

export class AssetDto extends TenantEntityDto implements IAssetDto {
    file?: FileDto | undefined;
    url?: string | undefined;
    name!: string;
    description?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    x?: number | undefined;
    y?: number | undefined;
    contentType!: string;
    tags?: string[] | undefined;
    sourceUrl?: string | undefined;
    licenseType?: LicenseType | undefined;
    licenseRestriction?: LicenseRestriction[] | undefined;
    licenseUrl?: string | undefined;
    copyright?: string | undefined;
    attribution?: string | undefined;
    metadata?: AssetMetadataDto | undefined;

    constructor(data?: IAssetDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : undefined as any;
            this.url = _data["url"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.contentType = _data["contentType"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.sourceUrl = _data["sourceUrl"];
            this.licenseType = _data["licenseType"];
            if (Array.isArray(_data["licenseRestriction"])) {
                this.licenseRestriction = [] as any;
                for (let item of _data["licenseRestriction"])
                    this.licenseRestriction!.push(item);
            }
            this.licenseUrl = _data["licenseUrl"];
            this.copyright = _data["copyright"];
            this.attribution = _data["attribution"];
            this.metadata = _data["metadata"] ? AssetMetadataDto.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static override fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        data["url"] = this.url;
        data["name"] = this.name;
        data["description"] = this.description;
        data["width"] = this.width;
        data["height"] = this.height;
        data["x"] = this.x;
        data["y"] = this.y;
        data["contentType"] = this.contentType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["sourceUrl"] = this.sourceUrl;
        data["licenseType"] = this.licenseType;
        if (Array.isArray(this.licenseRestriction)) {
            data["licenseRestriction"] = [];
            for (let item of this.licenseRestriction)
                data["licenseRestriction"].push(item);
        }
        data["licenseUrl"] = this.licenseUrl;
        data["copyright"] = this.copyright;
        data["attribution"] = this.attribution;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto extends ITenantEntityDto {
    file?: FileDto | undefined;
    url?: string | undefined;
    name: string;
    description?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    x?: number | undefined;
    y?: number | undefined;
    contentType: string;
    tags?: string[] | undefined;
    sourceUrl?: string | undefined;
    licenseType?: LicenseType | undefined;
    licenseRestriction?: LicenseRestriction[] | undefined;
    licenseUrl?: string | undefined;
    copyright?: string | undefined;
    attribution?: string | undefined;
    metadata?: AssetMetadataDto | undefined;
}

export class FileDto implements IFileDto {
    url?: string | undefined;
    id!: string;
    name!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    url?: string | undefined;
    id: string;
    name: string;
}

export enum LicenseType {
    Unknown = "unknown",
    PublicDomain = "publicDomain",
    CreativeCommons = "creativeCommons",
    Commercial = "commercial",
    CommercialRoyaltyFree = "commercialRoyaltyFree",
    CommercialRightsManaged = "commercialRightsManaged",
    CommercialExtended = "commercialExtended",
}

export enum LicenseRestriction {
    Attribution = "attribution",
    NoDerivatives = "noDerivatives",
    ShareAlike = "shareAlike",
    NonCommercial = "nonCommercial",
    EditorialUseOnly = "editorialUseOnly",
    ViewerRestriction = "viewerRestriction",
    NoMobileAppUse = "noMobileAppUse",
    NoDesktopAppUse = "noDesktopAppUse",
    NoWebUse = "noWebUse",
    NoPrintUse = "noPrintUse",
    NoBroadcastUse = "noBroadcastUse",
    NoAdvertisingUse = "noAdvertisingUse",
    NoSaaSUse = "noSaaSUse",
}

export class AssetMetadataDto implements IAssetMetadataDto {
    comment?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    orientation?: ImageOrientation | undefined;
    flashFired?: boolean | undefined;
    lensModel?: string | undefined;
    focalLength?: number | undefined;
    exposureTime?: number | undefined;
    fNumber?: number | undefined;
    isoSpeedRatings?: number | undefined;
    cameraModel?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    altitude?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    software?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    duration?: string | undefined;
    codecs?: string[] | undefined;
    frameRate?: number | undefined;
    bitrate?: number | undefined;
    pageCount?: number | undefined;

    constructor(data?: IAssetMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.orientation = _data["orientation"];
            this.flashFired = _data["flashFired"];
            this.lensModel = _data["lensModel"];
            this.focalLength = _data["focalLength"];
            this.exposureTime = _data["exposureTime"];
            this.fNumber = _data["fNumber"];
            this.isoSpeedRatings = _data["isoSpeedRatings"];
            this.cameraModel = _data["cameraModel"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.altitude = _data["altitude"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.software = _data["software"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["codecs"])) {
                this.codecs = [] as any;
                for (let item of _data["codecs"])
                    this.codecs!.push(item);
            }
            this.frameRate = _data["frameRate"];
            this.bitrate = _data["bitrate"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): AssetMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["title"] = this.title;
        data["description"] = this.description;
        data["source"] = this.source;
        data["orientation"] = this.orientation;
        data["flashFired"] = this.flashFired;
        data["lensModel"] = this.lensModel;
        data["focalLength"] = this.focalLength;
        data["exposureTime"] = this.exposureTime;
        data["fNumber"] = this.fNumber;
        data["isoSpeedRatings"] = this.isoSpeedRatings;
        data["cameraModel"] = this.cameraModel;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["altitude"] = this.altitude;
        data["make"] = this.make;
        data["model"] = this.model;
        data["software"] = this.software;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["duration"] = this.duration;
        if (Array.isArray(this.codecs)) {
            data["codecs"] = [];
            for (let item of this.codecs)
                data["codecs"].push(item);
        }
        data["frameRate"] = this.frameRate;
        data["bitrate"] = this.bitrate;
        data["pageCount"] = this.pageCount;
        return data;
    }

    clone(): AssetMetadataDto {
        const json = this.toJSON();
        let result = new AssetMetadataDto();
        result.init(json);
        return result;
    }
}

export interface IAssetMetadataDto {
    comment?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    source?: string | undefined;
    orientation?: ImageOrientation | undefined;
    flashFired?: boolean | undefined;
    lensModel?: string | undefined;
    focalLength?: number | undefined;
    exposureTime?: number | undefined;
    fNumber?: number | undefined;
    isoSpeedRatings?: number | undefined;
    cameraModel?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    altitude?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    software?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    duration?: string | undefined;
    codecs?: string[] | undefined;
    frameRate?: number | undefined;
    bitrate?: number | undefined;
    pageCount?: number | undefined;
}

export enum ImageOrientation {
    None = "none",
    TopLeft = "topLeft",
    TopRight = "topRight",
    BottomRight = "bottomRight",
    BottomLeft = "bottomLeft",
    LeftTop = "leftTop",
    RightTop = "rightTop",
    RightBottom = "rightBottom",
    LeftBottom = "leftBottom",
}

export enum ProjectVisibility {
    Private = "private",
    Internal = "internal",
    Public = "public",
}

export class TenantLanguageDto extends TenantEntityDto implements ITenantLanguageDto {
    name!: string;
    code!: string;
    icon?: AssetDto | undefined;
    fallbackLanguages!: TenantLanguageDto[];

    constructor(data?: ITenantLanguageDto) {
        super(data);
        if (!data) {
            this.fallbackLanguages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.icon = _data["icon"] ? AssetDto.fromJS(_data["icon"]) : undefined as any;
            if (Array.isArray(_data["fallbackLanguages"])) {
                this.fallbackLanguages = [] as any;
                for (let item of _data["fallbackLanguages"])
                    this.fallbackLanguages!.push(TenantLanguageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TenantLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLanguageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["icon"] = this.icon ? this.icon.toJSON() : undefined as any;
        if (Array.isArray(this.fallbackLanguages)) {
            data["fallbackLanguages"] = [];
            for (let item of this.fallbackLanguages)
                data["fallbackLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TenantLanguageDto {
        const json = this.toJSON();
        let result = new TenantLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLanguageDto extends ITenantEntityDto {
    name: string;
    code: string;
    icon?: AssetDto | undefined;
    fallbackLanguages: TenantLanguageDto[];
}

export class PaginatedListOfTenantQuestionnaireDto implements IPaginatedListOfTenantQuestionnaireDto {
    items!: TenantQuestionnaireDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantQuestionnaireDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantQuestionnaireDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantQuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantQuestionnaireDto {
    items: TenantQuestionnaireDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantQuestionnaireDto implements ITenantQuestionnaireDto {
    tenant!: TenantDto;
    questionnaire!: QuestionnaireDto;

    constructor(data?: ITenantQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tenant = new TenantDto();
            this.questionnaire = new QuestionnaireDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : new TenantDto();
            this.questionnaire = _data["questionnaire"] ? QuestionnaireDto.fromJS(_data["questionnaire"]) : new QuestionnaireDto();
        }
    }

    static fromJS(data: any): TenantQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : undefined as any;
        return data;
    }

    clone(): TenantQuestionnaireDto {
        const json = this.toJSON();
        let result = new TenantQuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface ITenantQuestionnaireDto {
    tenant: TenantDto;
    questionnaire: QuestionnaireDto;
}

export abstract class ContainerDto implements IContainerDto {
    id!: string;
    projectId?: string | undefined;
    name!: string;
    uniqueLabel!: string;
    version?: number;
    defaultLanguageId?: string | undefined;
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created!: Date;
    lastModified!: Date;

    constructor(data?: IContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.version = _data["version"];
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContainerDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ContainerDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["version"] = this.version;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["hidden"] = this.hidden ? this.hidden.toISOString() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }

    clone(): ContainerDto {
        throw new Error("The abstract class 'ContainerDto' cannot be instantiated.");
    }
}

export interface IContainerDto {
    id: string;
    projectId?: string | undefined;
    name: string;
    uniqueLabel: string;
    version?: number;
    defaultLanguageId?: string | undefined;
    tags?: string[] | undefined;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created: Date;
    lastModified: Date;
}

export class QuestionnaireDto extends ContainerDto implements IQuestionnaireDto {
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;

    constructor(data?: IQuestionnaireDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
        }
    }

    static override fromJS(data: any): QuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireDto {
        const json = this.toJSON();
        let result = new QuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireDto extends IContainerDto {
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
}

export enum QuestionnaireInstantiationMode {
    None = "none",
    Manual = "manual",
    Auto = "auto",
    Both = "both",
}

export enum QuestionnaireEditingMode {
    Anytime = "anytime",
    UntilCompleted = "untilCompleted",
}

export class UpdateCurrentUserCommand implements IUpdateCurrentUserCommand {
    email!: string;
    phoneNumber?: string | undefined;
    honorificPrefix?: string | undefined;
    givenName?: string | undefined;
    additionalName?: string | undefined;
    familyName?: string | undefined;
    honorificSuffix?: string | undefined;
    streetAddress?: string | undefined;
    addressLevel1?: string | undefined;
    addressLevel2?: string | undefined;
    addressLevel3?: string | undefined;
    addressLevel4?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    language?: string | undefined;
    birthDay?: Date | undefined;
    sex?: string | undefined;

    constructor(data?: IUpdateCurrentUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.honorificPrefix = _data["honorificPrefix"];
            this.givenName = _data["givenName"];
            this.additionalName = _data["additionalName"];
            this.familyName = _data["familyName"];
            this.honorificSuffix = _data["honorificSuffix"];
            this.streetAddress = _data["streetAddress"];
            this.addressLevel1 = _data["addressLevel1"];
            this.addressLevel2 = _data["addressLevel2"];
            this.addressLevel3 = _data["addressLevel3"];
            this.addressLevel4 = _data["addressLevel4"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.language = _data["language"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.sex = _data["sex"];
        }
    }

    static fromJS(data: any): UpdateCurrentUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrentUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["honorificPrefix"] = this.honorificPrefix;
        data["givenName"] = this.givenName;
        data["additionalName"] = this.additionalName;
        data["familyName"] = this.familyName;
        data["honorificSuffix"] = this.honorificSuffix;
        data["streetAddress"] = this.streetAddress;
        data["addressLevel1"] = this.addressLevel1;
        data["addressLevel2"] = this.addressLevel2;
        data["addressLevel3"] = this.addressLevel3;
        data["addressLevel4"] = this.addressLevel4;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["language"] = this.language;
        data["birthDay"] = this.birthDay ? formatDate(this.birthDay) : undefined as any;
        data["sex"] = this.sex;
        return data;
    }

    clone(): UpdateCurrentUserCommand {
        const json = this.toJSON();
        let result = new UpdateCurrentUserCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateCurrentUserCommand {
    email: string;
    phoneNumber?: string | undefined;
    honorificPrefix?: string | undefined;
    givenName?: string | undefined;
    additionalName?: string | undefined;
    familyName?: string | undefined;
    honorificSuffix?: string | undefined;
    streetAddress?: string | undefined;
    addressLevel1?: string | undefined;
    addressLevel2?: string | undefined;
    addressLevel3?: string | undefined;
    addressLevel4?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    language?: string | undefined;
    birthDay?: Date | undefined;
    sex?: string | undefined;
}

export class UpdateCurrentUserPasswordCommand implements IUpdateCurrentUserPasswordCommand {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IUpdateCurrentUserPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateCurrentUserPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrentUserPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): UpdateCurrentUserPasswordCommand {
        const json = this.toJSON();
        let result = new UpdateCurrentUserPasswordCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateCurrentUserPasswordCommand {
    oldPassword: string;
    newPassword: string;
}

export class PaginatedListOfLanguageDto implements IPaginatedListOfLanguageDto {
    items!: LanguageDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfLanguageDto {
        const json = this.toJSON();
        let result = new PaginatedListOfLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfLanguageDto {
    items: LanguageDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class LanguageDto implements ILanguageDto {
    id!: string;
    name!: string;
    code!: string;
    fallbackLanguages!: LanguageDto[];

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.fallbackLanguages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["fallbackLanguages"])) {
                this.fallbackLanguages = [] as any;
                for (let item of _data["fallbackLanguages"])
                    this.fallbackLanguages!.push(LanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.fallbackLanguages)) {
            data["fallbackLanguages"] = [];
            for (let item of this.fallbackLanguages)
                data["fallbackLanguages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageDto {
    id: string;
    name: string;
    code: string;
    fallbackLanguages: LanguageDto[];
}

export class DeploymentInformation implements IDeploymentInformation {
    deploymentTag!: string;
    deploymentLastUpdated!: Date;
    deploymentReplicas!: number;
    deploymentStatus!: string[];
    backendDeploymentTag!: string;
    backendDeploymentLastUpdated!: Date;
    backendDeploymentReplicas!: number;
    backendDeploymentStatus!: string[];
    databaseActualSizeBytes!: number;
    databaseRequestedVolumeSize!: string;
    databaseReplicas!: number;
    databaseStatus!: string[];
    databaseCombinedVolumeCapacityBytes!: number;
    databaseCombinedVolumeUsedBytes!: number;
    databaseCombinedVolumeAvailableBytes!: number;
    postgresSingleInstance?: boolean | undefined;

    constructor(data?: IDeploymentInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.deploymentStatus = [];
            this.backendDeploymentStatus = [];
            this.databaseStatus = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentTag = _data["deploymentTag"];
            this.deploymentLastUpdated = _data["deploymentLastUpdated"] ? new Date(_data["deploymentLastUpdated"].toString()) : undefined as any;
            this.deploymentReplicas = _data["deploymentReplicas"];
            if (Array.isArray(_data["deploymentStatus"])) {
                this.deploymentStatus = [] as any;
                for (let item of _data["deploymentStatus"])
                    this.deploymentStatus!.push(item);
            }
            this.backendDeploymentTag = _data["backendDeploymentTag"];
            this.backendDeploymentLastUpdated = _data["backendDeploymentLastUpdated"] ? new Date(_data["backendDeploymentLastUpdated"].toString()) : undefined as any;
            this.backendDeploymentReplicas = _data["backendDeploymentReplicas"];
            if (Array.isArray(_data["backendDeploymentStatus"])) {
                this.backendDeploymentStatus = [] as any;
                for (let item of _data["backendDeploymentStatus"])
                    this.backendDeploymentStatus!.push(item);
            }
            this.databaseActualSizeBytes = _data["databaseActualSizeBytes"];
            this.databaseRequestedVolumeSize = _data["databaseRequestedVolumeSize"];
            this.databaseReplicas = _data["databaseReplicas"];
            if (Array.isArray(_data["databaseStatus"])) {
                this.databaseStatus = [] as any;
                for (let item of _data["databaseStatus"])
                    this.databaseStatus!.push(item);
            }
            this.databaseCombinedVolumeCapacityBytes = _data["databaseCombinedVolumeCapacityBytes"];
            this.databaseCombinedVolumeUsedBytes = _data["databaseCombinedVolumeUsedBytes"];
            this.databaseCombinedVolumeAvailableBytes = _data["databaseCombinedVolumeAvailableBytes"];
            this.postgresSingleInstance = _data["postgresSingleInstance"];
        }
    }

    static fromJS(data: any): DeploymentInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentTag"] = this.deploymentTag;
        data["deploymentLastUpdated"] = this.deploymentLastUpdated ? this.deploymentLastUpdated.toISOString() : undefined as any;
        data["deploymentReplicas"] = this.deploymentReplicas;
        if (Array.isArray(this.deploymentStatus)) {
            data["deploymentStatus"] = [];
            for (let item of this.deploymentStatus)
                data["deploymentStatus"].push(item);
        }
        data["backendDeploymentTag"] = this.backendDeploymentTag;
        data["backendDeploymentLastUpdated"] = this.backendDeploymentLastUpdated ? this.backendDeploymentLastUpdated.toISOString() : undefined as any;
        data["backendDeploymentReplicas"] = this.backendDeploymentReplicas;
        if (Array.isArray(this.backendDeploymentStatus)) {
            data["backendDeploymentStatus"] = [];
            for (let item of this.backendDeploymentStatus)
                data["backendDeploymentStatus"].push(item);
        }
        data["databaseActualSizeBytes"] = this.databaseActualSizeBytes;
        data["databaseRequestedVolumeSize"] = this.databaseRequestedVolumeSize;
        data["databaseReplicas"] = this.databaseReplicas;
        if (Array.isArray(this.databaseStatus)) {
            data["databaseStatus"] = [];
            for (let item of this.databaseStatus)
                data["databaseStatus"].push(item);
        }
        data["databaseCombinedVolumeCapacityBytes"] = this.databaseCombinedVolumeCapacityBytes;
        data["databaseCombinedVolumeUsedBytes"] = this.databaseCombinedVolumeUsedBytes;
        data["databaseCombinedVolumeAvailableBytes"] = this.databaseCombinedVolumeAvailableBytes;
        data["postgresSingleInstance"] = this.postgresSingleInstance;
        return data;
    }

    clone(): DeploymentInformation {
        const json = this.toJSON();
        let result = new DeploymentInformation();
        result.init(json);
        return result;
    }
}

export interface IDeploymentInformation {
    deploymentTag: string;
    deploymentLastUpdated: Date;
    deploymentReplicas: number;
    deploymentStatus: string[];
    backendDeploymentTag: string;
    backendDeploymentLastUpdated: Date;
    backendDeploymentReplicas: number;
    backendDeploymentStatus: string[];
    databaseActualSizeBytes: number;
    databaseRequestedVolumeSize: string;
    databaseReplicas: number;
    databaseStatus: string[];
    databaseCombinedVolumeCapacityBytes: number;
    databaseCombinedVolumeUsedBytes: number;
    databaseCombinedVolumeAvailableBytes: number;
    postgresSingleInstance?: boolean | undefined;
}

export class PaginatedListOfTenantWithDeploymentInformationDto implements IPaginatedListOfTenantWithDeploymentInformationDto {
    items!: TenantWithDeploymentInformationDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantWithDeploymentInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantWithDeploymentInformationDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantWithDeploymentInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantWithDeploymentInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantWithDeploymentInformationDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantWithDeploymentInformationDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantWithDeploymentInformationDto {
    items: TenantWithDeploymentInformationDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantWithDeploymentInformationDto implements ITenantWithDeploymentInformationDto {
    tenant!: TenantDto;
    deploymentInformation!: DeploymentInformation;

    constructor(data?: ITenantWithDeploymentInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tenant = new TenantDto();
            this.deploymentInformation = new DeploymentInformation();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : new TenantDto();
            this.deploymentInformation = _data["deploymentInformation"] ? DeploymentInformation.fromJS(_data["deploymentInformation"]) : new DeploymentInformation();
        }
    }

    static fromJS(data: any): TenantWithDeploymentInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantWithDeploymentInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["deploymentInformation"] = this.deploymentInformation ? this.deploymentInformation.toJSON() : undefined as any;
        return data;
    }

    clone(): TenantWithDeploymentInformationDto {
        const json = this.toJSON();
        let result = new TenantWithDeploymentInformationDto();
        result.init(json);
        return result;
    }
}

export interface ITenantWithDeploymentInformationDto {
    tenant: TenantDto;
    deploymentInformation: DeploymentInformation;
}

export class TenantConfigurationDto implements ITenantConfigurationDto {
    postgresSingleInstance?: boolean | undefined;

    constructor(data?: ITenantConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgresSingleInstance = _data["postgresSingleInstance"];
        }
    }

    static fromJS(data: any): TenantConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgresSingleInstance"] = this.postgresSingleInstance;
        return data;
    }

    clone(): TenantConfigurationDto {
        const json = this.toJSON();
        let result = new TenantConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface ITenantConfigurationDto {
    postgresSingleInstance?: boolean | undefined;
}

export class UpdateGatewayVersionCommand implements IUpdateGatewayVersionCommand {

    constructor(data?: IUpdateGatewayVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateGatewayVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGatewayVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateGatewayVersionCommand {
        const json = this.toJSON();
        let result = new UpdateGatewayVersionCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateGatewayVersionCommand {
}

export class UpdateGatewayBackendVersionCommand implements IUpdateGatewayBackendVersionCommand {

    constructor(data?: IUpdateGatewayBackendVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateGatewayBackendVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGatewayBackendVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateGatewayBackendVersionCommand {
        const json = this.toJSON();
        let result = new UpdateGatewayBackendVersionCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateGatewayBackendVersionCommand {
}

export class UpdateTenantVersionsCommand implements IUpdateTenantVersionsCommand {
    tenantIds!: string[];

    constructor(data?: IUpdateTenantVersionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tenantIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTenantVersionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantVersionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data;
    }

    clone(): UpdateTenantVersionsCommand {
        const json = this.toJSON();
        let result = new UpdateTenantVersionsCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantVersionsCommand {
    tenantIds: string[];
}

export class SetTenantImageTagCommand implements ISetTenantImageTagCommand {
    tenantImageTag!: string;
    tenantIds!: string[];

    constructor(data?: ISetTenantImageTagCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tenantIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantImageTag = _data["tenantImageTag"];
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetTenantImageTagCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetTenantImageTagCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantImageTag"] = this.tenantImageTag;
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data;
    }

    clone(): SetTenantImageTagCommand {
        const json = this.toJSON();
        let result = new SetTenantImageTagCommand();
        result.init(json);
        return result;
    }
}

export interface ISetTenantImageTagCommand {
    tenantImageTag: string;
    tenantIds: string[];
}

export class SetTenantBackendImageTagCommand implements ISetTenantBackendImageTagCommand {
    tenantBackendImageTag!: string;
    tenantIds!: string[];

    constructor(data?: ISetTenantBackendImageTagCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tenantIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantBackendImageTag = _data["tenantBackendImageTag"];
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetTenantBackendImageTagCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetTenantBackendImageTagCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantBackendImageTag"] = this.tenantBackendImageTag;
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data;
    }

    clone(): SetTenantBackendImageTagCommand {
        const json = this.toJSON();
        let result = new SetTenantBackendImageTagCommand();
        result.init(json);
        return result;
    }
}

export interface ISetTenantBackendImageTagCommand {
    tenantBackendImageTag: string;
    tenantIds: string[];
}

export class PaginatedListOfEmailTemplateDto implements IPaginatedListOfEmailTemplateDto {
    items!: EmailTemplateDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmailTemplateDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfEmailTemplateDto {
        const json = this.toJSON();
        let result = new PaginatedListOfEmailTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfEmailTemplateDto {
    items: EmailTemplateDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class EmailTemplateDto implements IEmailTemplateDto {
    id!: string;
    name!: string;
    actionType!: EmailActionType;
    isDefault!: boolean;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.actionType = _data["actionType"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["actionType"] = this.actionType;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): EmailTemplateDto {
        const json = this.toJSON();
        let result = new EmailTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IEmailTemplateDto {
    id: string;
    name: string;
    actionType: EmailActionType;
    isDefault: boolean;
}

export enum EmailActionType {
    ConfirmAccount = "confirmAccount",
    ResetPassword = "resetPassword",
    ConfirmEmailChange = "confirmEmailChange",
    CompleteInvitedRegistration = "completeInvitedRegistration",
    AdminMessage = "adminMessage",
}

export class EmailTemplateDetailsDto implements IEmailTemplateDetailsDto {
    id!: string;
    name!: string;
    actionType!: EmailActionType;
    isDefault!: boolean;
    subject!: InternationalizedStringDto;
    templateVariableTranslations!: { [key: string]: InternationalizedStringDto; };
    dynamicTemplateVariables!: EmailTemplateDynamicVariable[];
    templateString!: string;
    templateType!: EmailTemplateType;
    templateSections!: { [key: string]: InternationalizedDocumentDto; };
    languages!: LanguageDto[];

    constructor(data?: IEmailTemplateDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.subject = new InternationalizedStringDto();
            this.templateVariableTranslations = {};
            this.dynamicTemplateVariables = [];
            this.templateSections = {};
            this.languages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.actionType = _data["actionType"];
            this.isDefault = _data["isDefault"];
            this.subject = _data["subject"] ? InternationalizedStringDto.fromJS(_data["subject"]) : new InternationalizedStringDto();
            if (_data["templateVariableTranslations"]) {
                this.templateVariableTranslations = {} as any;
                for (let key in _data["templateVariableTranslations"]) {
                    if (_data["templateVariableTranslations"].hasOwnProperty(key))
                        (this.templateVariableTranslations as any)![key] = _data["templateVariableTranslations"][key] ? InternationalizedStringDto.fromJS(_data["templateVariableTranslations"][key]) : new InternationalizedStringDto();
                }
            }
            if (Array.isArray(_data["dynamicTemplateVariables"])) {
                this.dynamicTemplateVariables = [] as any;
                for (let item of _data["dynamicTemplateVariables"])
                    this.dynamicTemplateVariables!.push(item);
            }
            this.templateString = _data["templateString"];
            this.templateType = _data["templateType"];
            if (_data["templateSections"]) {
                this.templateSections = {} as any;
                for (let key in _data["templateSections"]) {
                    if (_data["templateSections"].hasOwnProperty(key))
                        (this.templateSections as any)![key] = _data["templateSections"][key] ? InternationalizedDocumentDto.fromJS(_data["templateSections"][key]) : new InternationalizedDocumentDto();
                }
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailTemplateDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["actionType"] = this.actionType;
        data["isDefault"] = this.isDefault;
        data["subject"] = this.subject ? this.subject.toJSON() : undefined as any;
        if (this.templateVariableTranslations) {
            data["templateVariableTranslations"] = {};
            for (let key in this.templateVariableTranslations) {
                if (this.templateVariableTranslations.hasOwnProperty(key))
                    (data["templateVariableTranslations"] as any)[key] = this.templateVariableTranslations[key] ? this.templateVariableTranslations[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.dynamicTemplateVariables)) {
            data["dynamicTemplateVariables"] = [];
            for (let item of this.dynamicTemplateVariables)
                data["dynamicTemplateVariables"].push(item);
        }
        data["templateString"] = this.templateString;
        data["templateType"] = this.templateType;
        if (this.templateSections) {
            data["templateSections"] = {};
            for (let key in this.templateSections) {
                if (this.templateSections.hasOwnProperty(key))
                    (data["templateSections"] as any)[key] = this.templateSections[key] ? this.templateSections[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): EmailTemplateDetailsDto {
        const json = this.toJSON();
        let result = new EmailTemplateDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IEmailTemplateDetailsDto {
    id: string;
    name: string;
    actionType: EmailActionType;
    isDefault: boolean;
    subject: InternationalizedStringDto;
    templateVariableTranslations: { [key: string]: InternationalizedStringDto; };
    dynamicTemplateVariables: EmailTemplateDynamicVariable[];
    templateString: string;
    templateType: EmailTemplateType;
    templateSections: { [key: string]: InternationalizedDocumentDto; };
    languages: LanguageDto[];
}

export class InternationalizedStringDto implements IInternationalizedStringDto {
    translations!: { [key: string]: string; };

    constructor(data?: IInternationalizedStringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (this.translations as any)![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): InternationalizedStringDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizedStringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (data["translations"] as any)[key] = (this.translations as any)[key];
            }
        }
        return data;
    }

    clone(): InternationalizedStringDto {
        const json = this.toJSON();
        let result = new InternationalizedStringDto();
        result.init(json);
        return result;
    }
}

export interface IInternationalizedStringDto {
    translations: { [key: string]: string; };
}

export enum EmailTemplateDynamicVariable {
    GivenName = "givenName",
    FamilyName = "familyName",
    ActionLink = "actionLink",
    NewEmail = "newEmail",
    Title = "title",
    Content = "content",
}

export enum EmailTemplateType {
    Mjml = "mjml",
}

export class InternationalizedDocumentDto implements IInternationalizedDocumentDto {
    translations!: { [key: string]: Node; };

    constructor(data?: IInternationalizedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (this.translations as any)![key] = _data["translations"][key] ? Node.fromJS(_data["translations"][key]) : new Node();
                }
            }
        }
    }

    static fromJS(data: any): InternationalizedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (data["translations"] as any)[key] = this.translations[key] ? this.translations[key].toJSON() : undefined as any;
            }
        }
        return data;
    }

    clone(): InternationalizedDocumentDto {
        const json = this.toJSON();
        let result = new InternationalizedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IInternationalizedDocumentDto {
    translations: { [key: string]: Node; };
}

export class Node implements INode {
    type!: NodeType;
    attrs?: NodeAttribute | undefined;
    content?: Node[] | undefined;
    marks?: Mark[] | undefined;
    text?: string | undefined;

    constructor(data?: INode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.attrs = _data["attrs"] ? NodeAttribute.fromJS(_data["attrs"]) : undefined as any;
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(Node.fromJS(item));
            }
            if (Array.isArray(_data["marks"])) {
                this.marks = [] as any;
                for (let item of _data["marks"])
                    this.marks!.push(Mark.fromJS(item));
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Node {
        data = typeof data === 'object' ? data : {};
        let result = new Node();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["attrs"] = this.attrs ? this.attrs.toJSON() : undefined as any;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.marks)) {
            data["marks"] = [];
            for (let item of this.marks)
                data["marks"].push(item ? item.toJSON() : undefined as any);
        }
        data["text"] = this.text;
        return data;
    }

    clone(): Node {
        const json = this.toJSON();
        let result = new Node();
        result.init(json);
        return result;
    }
}

export interface INode {
    type: NodeType;
    attrs?: NodeAttribute | undefined;
    content?: Node[] | undefined;
    marks?: Mark[] | undefined;
    text?: string | undefined;
}

export enum NodeType {
    Blockquote = "blockquote",
    BulletList = "bulletList",
    Doc = "doc",
    HardBreak = "hardBreak",
    Heading = "heading",
    HorizontalRule = "horizontalRule",
    ListItem = "listItem",
    OrderedList = "orderedList",
    Paragraph = "paragraph",
    Table = "table",
    TableRow = "tableRow",
    TableHeader = "tableHeader",
    TableCell = "tableCell",
    Text = "text",
    Video = "video",
    Audio = "audio",
    Image = "image",
    Html = "html",
    Details = "details",
    DetailsSummary = "detailsSummary",
    DetailsContent = "detailsContent",
    Figure = "figure",
    Figcaption = "figcaption",
    Panel = "panel",
    Token = "token",
}

export class NodeAttribute implements INodeAttribute {
    display?: string | undefined;
    level?: number | undefined;
    textAlign?: string | undefined;
    colspan?: number | undefined;
    rowspan?: number | undefined;
    colwidth?: number | undefined;
    start?: number | undefined;
    assetId?: string | undefined;
    src?: string | undefined;
    alt?: string | undefined;
    title?: string | undefined;
    caption?: string | undefined;
    html?: string | undefined;
    type?: string | undefined;
    label?: string | undefined;
    id?: string | undefined;

    constructor(data?: INodeAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.display = _data["display"];
            this.level = _data["level"];
            this.textAlign = _data["textAlign"];
            this.colspan = _data["colspan"];
            this.rowspan = _data["rowspan"];
            this.colwidth = _data["colwidth"];
            this.start = _data["start"];
            this.assetId = _data["assetId"];
            this.src = _data["src"];
            this.alt = _data["alt"];
            this.title = _data["title"];
            this.caption = _data["caption"];
            this.html = _data["html"];
            this.type = _data["type"];
            this.label = _data["label"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NodeAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new NodeAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["display"] = this.display;
        data["level"] = this.level;
        data["textAlign"] = this.textAlign;
        data["colspan"] = this.colspan;
        data["rowspan"] = this.rowspan;
        data["colwidth"] = this.colwidth;
        data["start"] = this.start;
        data["assetId"] = this.assetId;
        data["src"] = this.src;
        data["alt"] = this.alt;
        data["title"] = this.title;
        data["caption"] = this.caption;
        data["html"] = this.html;
        data["type"] = this.type;
        data["label"] = this.label;
        data["id"] = this.id;
        return data;
    }

    clone(): NodeAttribute {
        const json = this.toJSON();
        let result = new NodeAttribute();
        result.init(json);
        return result;
    }
}

export interface INodeAttribute {
    display?: string | undefined;
    level?: number | undefined;
    textAlign?: string | undefined;
    colspan?: number | undefined;
    rowspan?: number | undefined;
    colwidth?: number | undefined;
    start?: number | undefined;
    assetId?: string | undefined;
    src?: string | undefined;
    alt?: string | undefined;
    title?: string | undefined;
    caption?: string | undefined;
    html?: string | undefined;
    type?: string | undefined;
    label?: string | undefined;
    id?: string | undefined;
}

export class Mark implements IMark {
    type!: MarkType;
    attrs?: MarkAttribute | undefined;

    constructor(data?: IMark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.attrs = _data["attrs"] ? MarkAttribute.fromJS(_data["attrs"]) : undefined as any;
        }
    }

    static fromJS(data: any): Mark {
        data = typeof data === 'object' ? data : {};
        let result = new Mark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["attrs"] = this.attrs ? this.attrs.toJSON() : undefined as any;
        return data;
    }

    clone(): Mark {
        const json = this.toJSON();
        let result = new Mark();
        result.init(json);
        return result;
    }
}

export interface IMark {
    type: MarkType;
    attrs?: MarkAttribute | undefined;
}

export enum MarkType {
    Bold = "bold",
    Italic = "italic",
    Link = "link",
    Strike = "strike",
    Subscript = "subscript",
    Superscript = "superscript",
    Underline = "underline",
    Reference = "reference",
}

export class MarkAttribute implements IMarkAttribute {
    target?: string | undefined;
    title?: string | undefined;
    class?: string | undefined;
    rel?: string | undefined;
    href?: string | undefined;
    fileId?: string | undefined;
    referenceId?: string | undefined;
    referenceType?: ReferenceType | undefined;

    constructor(data?: IMarkAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.title = _data["title"];
            this.class = _data["class"];
            this.rel = _data["rel"];
            this.href = _data["href"];
            this.fileId = _data["fileId"];
            this.referenceId = _data["referenceId"];
            this.referenceType = _data["referenceType"];
        }
    }

    static fromJS(data: any): MarkAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["title"] = this.title;
        data["class"] = this.class;
        data["rel"] = this.rel;
        data["href"] = this.href;
        data["fileId"] = this.fileId;
        data["referenceId"] = this.referenceId;
        data["referenceType"] = this.referenceType;
        return data;
    }

    clone(): MarkAttribute {
        const json = this.toJSON();
        let result = new MarkAttribute();
        result.init(json);
        return result;
    }
}

export interface IMarkAttribute {
    target?: string | undefined;
    title?: string | undefined;
    class?: string | undefined;
    rel?: string | undefined;
    href?: string | undefined;
    fileId?: string | undefined;
    referenceId?: string | undefined;
    referenceType?: ReferenceType | undefined;
}

export enum ReferenceType {
    Asset = "asset",
    Page = "page",
}

export class CreateEmailTemplateCommand implements ICreateEmailTemplateCommand {
    name!: string;
    actionType!: EmailActionType;
    isDefault!: boolean;

    constructor(data?: ICreateEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.actionType = _data["actionType"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["actionType"] = this.actionType;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): CreateEmailTemplateCommand {
        const json = this.toJSON();
        let result = new CreateEmailTemplateCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateEmailTemplateCommand {
    name: string;
    actionType: EmailActionType;
    isDefault: boolean;
}

export class UpdateEmailTemplateCommand implements IUpdateEmailTemplateCommand {
    emailTemplateId!: string;
    name!: string;
    actionType!: EmailActionType;
    isDefault!: boolean;
    subject!: InternationalizedStringDto;
    templateVariableTranslations!: { [key: string]: InternationalizedStringDto; };
    templateString!: string;
    templateType!: EmailTemplateType;
    templateSections!: { [key: string]: InternationalizedDocumentDto; };
    languageCodes!: string[];

    constructor(data?: IUpdateEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.subject = new InternationalizedStringDto();
            this.templateVariableTranslations = {};
            this.templateSections = {};
            this.languageCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplateId = _data["emailTemplateId"];
            this.name = _data["name"];
            this.actionType = _data["actionType"];
            this.isDefault = _data["isDefault"];
            this.subject = _data["subject"] ? InternationalizedStringDto.fromJS(_data["subject"]) : new InternationalizedStringDto();
            if (_data["templateVariableTranslations"]) {
                this.templateVariableTranslations = {} as any;
                for (let key in _data["templateVariableTranslations"]) {
                    if (_data["templateVariableTranslations"].hasOwnProperty(key))
                        (this.templateVariableTranslations as any)![key] = _data["templateVariableTranslations"][key] ? InternationalizedStringDto.fromJS(_data["templateVariableTranslations"][key]) : new InternationalizedStringDto();
                }
            }
            this.templateString = _data["templateString"];
            this.templateType = _data["templateType"];
            if (_data["templateSections"]) {
                this.templateSections = {} as any;
                for (let key in _data["templateSections"]) {
                    if (_data["templateSections"].hasOwnProperty(key))
                        (this.templateSections as any)![key] = _data["templateSections"][key] ? InternationalizedDocumentDto.fromJS(_data["templateSections"][key]) : new InternationalizedDocumentDto();
                }
            }
            if (Array.isArray(_data["languageCodes"])) {
                this.languageCodes = [] as any;
                for (let item of _data["languageCodes"])
                    this.languageCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailTemplateId"] = this.emailTemplateId;
        data["name"] = this.name;
        data["actionType"] = this.actionType;
        data["isDefault"] = this.isDefault;
        data["subject"] = this.subject ? this.subject.toJSON() : undefined as any;
        if (this.templateVariableTranslations) {
            data["templateVariableTranslations"] = {};
            for (let key in this.templateVariableTranslations) {
                if (this.templateVariableTranslations.hasOwnProperty(key))
                    (data["templateVariableTranslations"] as any)[key] = this.templateVariableTranslations[key] ? this.templateVariableTranslations[key].toJSON() : undefined as any;
            }
        }
        data["templateString"] = this.templateString;
        data["templateType"] = this.templateType;
        if (this.templateSections) {
            data["templateSections"] = {};
            for (let key in this.templateSections) {
                if (this.templateSections.hasOwnProperty(key))
                    (data["templateSections"] as any)[key] = this.templateSections[key] ? this.templateSections[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.languageCodes)) {
            data["languageCodes"] = [];
            for (let item of this.languageCodes)
                data["languageCodes"].push(item);
        }
        return data;
    }

    clone(): UpdateEmailTemplateCommand {
        const json = this.toJSON();
        let result = new UpdateEmailTemplateCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmailTemplateCommand {
    emailTemplateId: string;
    name: string;
    actionType: EmailActionType;
    isDefault: boolean;
    subject: InternationalizedStringDto;
    templateVariableTranslations: { [key: string]: InternationalizedStringDto; };
    templateString: string;
    templateType: EmailTemplateType;
    templateSections: { [key: string]: InternationalizedDocumentDto; };
    languageCodes: string[];
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class SendMessageCommand implements ISendMessageCommand {
    userIds!: string[];
    channelType!: ChannelType;
    subject!: string;
    body!: string;

    constructor(data?: ISendMessageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.channelType = _data["channelType"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SendMessageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["channelType"] = this.channelType;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }

    clone(): SendMessageCommand {
        const json = this.toJSON();
        let result = new SendMessageCommand();
        result.init(json);
        return result;
    }
}

export interface ISendMessageCommand {
    userIds: string[];
    channelType: ChannelType;
    subject: string;
    body: string;
}

export enum ChannelType {
    Email = "email",
}

export class PaginatedListOfMessageLogEntryDto implements IPaginatedListOfMessageLogEntryDto {
    items!: MessageLogEntryDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfMessageLogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MessageLogEntryDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfMessageLogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfMessageLogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfMessageLogEntryDto {
        const json = this.toJSON();
        let result = new PaginatedListOfMessageLogEntryDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfMessageLogEntryDto {
    items: MessageLogEntryDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class MessageLogEntryDto implements IMessageLogEntryDto {
    id!: string;
    created!: Date;
    scheduled?: Date | undefined;
    sent?: Date | undefined;
    failed?: Date | undefined;
    channelType!: ChannelType;
    recipient!: string;
    subject!: string;
    status?: MessageStatus | undefined;

    constructor(data?: IMessageLogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.scheduled = _data["scheduled"] ? new Date(_data["scheduled"].toString()) : undefined as any;
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : undefined as any;
            this.failed = _data["failed"] ? new Date(_data["failed"].toString()) : undefined as any;
            this.channelType = _data["channelType"];
            this.recipient = _data["recipient"];
            this.subject = _data["subject"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MessageLogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageLogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["scheduled"] = this.scheduled ? this.scheduled.toISOString() : undefined as any;
        data["sent"] = this.sent ? this.sent.toISOString() : undefined as any;
        data["failed"] = this.failed ? this.failed.toISOString() : undefined as any;
        data["channelType"] = this.channelType;
        data["recipient"] = this.recipient;
        data["subject"] = this.subject;
        data["status"] = this.status;
        return data;
    }

    clone(): MessageLogEntryDto {
        const json = this.toJSON();
        let result = new MessageLogEntryDto();
        result.init(json);
        return result;
    }
}

export interface IMessageLogEntryDto {
    id: string;
    created: Date;
    scheduled?: Date | undefined;
    sent?: Date | undefined;
    failed?: Date | undefined;
    channelType: ChannelType;
    recipient: string;
    subject: string;
    status?: MessageStatus | undefined;
}

export enum MessageStatus {
    Queued = "queued",
    Sent = "sent",
    FailedQueuing = "failedQueuing",
    FailedProcessing = "failedProcessing",
    FailedSending = "failedSending",
}

export class MessageLogFilterOptionsDto implements IMessageLogFilterOptionsDto {
    channelTypes!: ChannelType[];
    statuses!: MessageStatus[];

    constructor(data?: IMessageLogFilterOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.channelTypes = [];
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["channelTypes"])) {
                this.channelTypes = [] as any;
                for (let item of _data["channelTypes"])
                    this.channelTypes!.push(item);
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
        }
    }

    static fromJS(data: any): MessageLogFilterOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageLogFilterOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.channelTypes)) {
            data["channelTypes"] = [];
            for (let item of this.channelTypes)
                data["channelTypes"].push(item);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        return data;
    }

    clone(): MessageLogFilterOptionsDto {
        const json = this.toJSON();
        let result = new MessageLogFilterOptionsDto();
        result.init(json);
        return result;
    }
}

export interface IMessageLogFilterOptionsDto {
    channelTypes: ChannelType[];
    statuses: MessageStatus[];
}

export class MessageLogEntryDetailsDto implements IMessageLogEntryDetailsDto {
    id!: string;
    created!: Date;
    scheduled?: Date | undefined;
    sent?: Date | undefined;
    failed?: Date | undefined;
    channelType!: ChannelType;
    recipient!: string;
    subject!: string;
    status?: MessageStatus | undefined;
    queueId?: string | undefined;
    channelId?: string | undefined;
    messageId?: string | undefined;
    cost?: number | undefined;
    error?: string | undefined;

    constructor(data?: IMessageLogEntryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.scheduled = _data["scheduled"] ? new Date(_data["scheduled"].toString()) : undefined as any;
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : undefined as any;
            this.failed = _data["failed"] ? new Date(_data["failed"].toString()) : undefined as any;
            this.channelType = _data["channelType"];
            this.recipient = _data["recipient"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.queueId = _data["queueId"];
            this.channelId = _data["channelId"];
            this.messageId = _data["messageId"];
            this.cost = _data["cost"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): MessageLogEntryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageLogEntryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["scheduled"] = this.scheduled ? this.scheduled.toISOString() : undefined as any;
        data["sent"] = this.sent ? this.sent.toISOString() : undefined as any;
        data["failed"] = this.failed ? this.failed.toISOString() : undefined as any;
        data["channelType"] = this.channelType;
        data["recipient"] = this.recipient;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["queueId"] = this.queueId;
        data["channelId"] = this.channelId;
        data["messageId"] = this.messageId;
        data["cost"] = this.cost;
        data["error"] = this.error;
        return data;
    }

    clone(): MessageLogEntryDetailsDto {
        const json = this.toJSON();
        let result = new MessageLogEntryDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IMessageLogEntryDetailsDto {
    id: string;
    created: Date;
    scheduled?: Date | undefined;
    sent?: Date | undefined;
    failed?: Date | undefined;
    channelType: ChannelType;
    recipient: string;
    subject: string;
    status?: MessageStatus | undefined;
    queueId?: string | undefined;
    channelId?: string | undefined;
    messageId?: string | undefined;
    cost?: number | undefined;
    error?: string | undefined;
}

export class PaginatedListOfOidcApplicationDto implements IPaginatedListOfOidcApplicationDto {
    items!: OidcApplicationDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfOidcApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OidcApplicationDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfOidcApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfOidcApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfOidcApplicationDto {
        const json = this.toJSON();
        let result = new PaginatedListOfOidcApplicationDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfOidcApplicationDto {
    items: OidcApplicationDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class OidcApplicationDto implements IOidcApplicationDto {
    id!: string;
    clientId!: string;
    displayName?: string | undefined;
    consentType?: string | undefined;
    isSystemApplication!: boolean;
    redirectUris!: string[];
    postLogoutRedirectUris!: string[];
    permissions!: string[];

    constructor(data?: IOidcApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.redirectUris = [];
            this.postLogoutRedirectUris = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.displayName = _data["displayName"];
            this.consentType = _data["consentType"];
            this.isSystemApplication = _data["isSystemApplication"];
            if (Array.isArray(_data["redirectUris"])) {
                this.redirectUris = [] as any;
                for (let item of _data["redirectUris"])
                    this.redirectUris!.push(item);
            }
            if (Array.isArray(_data["postLogoutRedirectUris"])) {
                this.postLogoutRedirectUris = [] as any;
                for (let item of _data["postLogoutRedirectUris"])
                    this.postLogoutRedirectUris!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): OidcApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OidcApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["displayName"] = this.displayName;
        data["consentType"] = this.consentType;
        data["isSystemApplication"] = this.isSystemApplication;
        if (Array.isArray(this.redirectUris)) {
            data["redirectUris"] = [];
            for (let item of this.redirectUris)
                data["redirectUris"].push(item);
        }
        if (Array.isArray(this.postLogoutRedirectUris)) {
            data["postLogoutRedirectUris"] = [];
            for (let item of this.postLogoutRedirectUris)
                data["postLogoutRedirectUris"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): OidcApplicationDto {
        const json = this.toJSON();
        let result = new OidcApplicationDto();
        result.init(json);
        return result;
    }
}

export interface IOidcApplicationDto {
    id: string;
    clientId: string;
    displayName?: string | undefined;
    consentType?: string | undefined;
    isSystemApplication: boolean;
    redirectUris: string[];
    postLogoutRedirectUris: string[];
    permissions: string[];
}

export class OidcApplicationDetailsDto implements IOidcApplicationDetailsDto {
    id!: string;
    clientId!: string;
    displayName?: string | undefined;
    consentType?: string | undefined;
    clientType?: string | undefined;
    applicationType?: string | undefined;
    isSystemApplication!: boolean;
    redirectUris!: string[];
    postLogoutRedirectUris!: string[];
    permissions!: string[];
    accessTokenLifetimeMinutes?: number | undefined;
    refreshTokenLifetimeMinutes?: number | undefined;

    constructor(data?: IOidcApplicationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.redirectUris = [];
            this.postLogoutRedirectUris = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.displayName = _data["displayName"];
            this.consentType = _data["consentType"];
            this.clientType = _data["clientType"];
            this.applicationType = _data["applicationType"];
            this.isSystemApplication = _data["isSystemApplication"];
            if (Array.isArray(_data["redirectUris"])) {
                this.redirectUris = [] as any;
                for (let item of _data["redirectUris"])
                    this.redirectUris!.push(item);
            }
            if (Array.isArray(_data["postLogoutRedirectUris"])) {
                this.postLogoutRedirectUris = [] as any;
                for (let item of _data["postLogoutRedirectUris"])
                    this.postLogoutRedirectUris!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.accessTokenLifetimeMinutes = _data["accessTokenLifetimeMinutes"];
            this.refreshTokenLifetimeMinutes = _data["refreshTokenLifetimeMinutes"];
        }
    }

    static fromJS(data: any): OidcApplicationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OidcApplicationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["displayName"] = this.displayName;
        data["consentType"] = this.consentType;
        data["clientType"] = this.clientType;
        data["applicationType"] = this.applicationType;
        data["isSystemApplication"] = this.isSystemApplication;
        if (Array.isArray(this.redirectUris)) {
            data["redirectUris"] = [];
            for (let item of this.redirectUris)
                data["redirectUris"].push(item);
        }
        if (Array.isArray(this.postLogoutRedirectUris)) {
            data["postLogoutRedirectUris"] = [];
            for (let item of this.postLogoutRedirectUris)
                data["postLogoutRedirectUris"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["accessTokenLifetimeMinutes"] = this.accessTokenLifetimeMinutes;
        data["refreshTokenLifetimeMinutes"] = this.refreshTokenLifetimeMinutes;
        return data;
    }

    clone(): OidcApplicationDetailsDto {
        const json = this.toJSON();
        let result = new OidcApplicationDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IOidcApplicationDetailsDto {
    id: string;
    clientId: string;
    displayName?: string | undefined;
    consentType?: string | undefined;
    clientType?: string | undefined;
    applicationType?: string | undefined;
    isSystemApplication: boolean;
    redirectUris: string[];
    postLogoutRedirectUris: string[];
    permissions: string[];
    accessTokenLifetimeMinutes?: number | undefined;
    refreshTokenLifetimeMinutes?: number | undefined;
}

export class CreateOidcApplicationCommand implements ICreateOidcApplicationCommand {
    clientId!: string;
    displayName?: string | undefined;
    clientType?: string | undefined;
    clientSecret?: string | undefined;
    consentType?: string | undefined;
    redirectUris!: string[];
    postLogoutRedirectUris!: string[];
    permissions!: string[];
    accessTokenLifetimeMinutes?: number | undefined;
    refreshTokenLifetimeMinutes?: number | undefined;

    constructor(data?: ICreateOidcApplicationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.redirectUris = [];
            this.postLogoutRedirectUris = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.displayName = _data["displayName"];
            this.clientType = _data["clientType"];
            this.clientSecret = _data["clientSecret"];
            this.consentType = _data["consentType"];
            if (Array.isArray(_data["redirectUris"])) {
                this.redirectUris = [] as any;
                for (let item of _data["redirectUris"])
                    this.redirectUris!.push(item);
            }
            if (Array.isArray(_data["postLogoutRedirectUris"])) {
                this.postLogoutRedirectUris = [] as any;
                for (let item of _data["postLogoutRedirectUris"])
                    this.postLogoutRedirectUris!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.accessTokenLifetimeMinutes = _data["accessTokenLifetimeMinutes"];
            this.refreshTokenLifetimeMinutes = _data["refreshTokenLifetimeMinutes"];
        }
    }

    static fromJS(data: any): CreateOidcApplicationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOidcApplicationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["displayName"] = this.displayName;
        data["clientType"] = this.clientType;
        data["clientSecret"] = this.clientSecret;
        data["consentType"] = this.consentType;
        if (Array.isArray(this.redirectUris)) {
            data["redirectUris"] = [];
            for (let item of this.redirectUris)
                data["redirectUris"].push(item);
        }
        if (Array.isArray(this.postLogoutRedirectUris)) {
            data["postLogoutRedirectUris"] = [];
            for (let item of this.postLogoutRedirectUris)
                data["postLogoutRedirectUris"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["accessTokenLifetimeMinutes"] = this.accessTokenLifetimeMinutes;
        data["refreshTokenLifetimeMinutes"] = this.refreshTokenLifetimeMinutes;
        return data;
    }

    clone(): CreateOidcApplicationCommand {
        const json = this.toJSON();
        let result = new CreateOidcApplicationCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateOidcApplicationCommand {
    clientId: string;
    displayName?: string | undefined;
    clientType?: string | undefined;
    clientSecret?: string | undefined;
    consentType?: string | undefined;
    redirectUris: string[];
    postLogoutRedirectUris: string[];
    permissions: string[];
    accessTokenLifetimeMinutes?: number | undefined;
    refreshTokenLifetimeMinutes?: number | undefined;
}

export class UpdateOidcApplicationCommand implements IUpdateOidcApplicationCommand {
    clientId!: string;
    displayName?: string | undefined;
    clientType?: string | undefined;
    clientSecret?: string | undefined;
    consentType?: string | undefined;
    redirectUris!: string[];
    postLogoutRedirectUris!: string[];
    permissions!: string[];
    accessTokenLifetimeMinutes?: number | undefined;
    refreshTokenLifetimeMinutes?: number | undefined;

    constructor(data?: IUpdateOidcApplicationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.redirectUris = [];
            this.postLogoutRedirectUris = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.displayName = _data["displayName"];
            this.clientType = _data["clientType"];
            this.clientSecret = _data["clientSecret"];
            this.consentType = _data["consentType"];
            if (Array.isArray(_data["redirectUris"])) {
                this.redirectUris = [] as any;
                for (let item of _data["redirectUris"])
                    this.redirectUris!.push(item);
            }
            if (Array.isArray(_data["postLogoutRedirectUris"])) {
                this.postLogoutRedirectUris = [] as any;
                for (let item of _data["postLogoutRedirectUris"])
                    this.postLogoutRedirectUris!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.accessTokenLifetimeMinutes = _data["accessTokenLifetimeMinutes"];
            this.refreshTokenLifetimeMinutes = _data["refreshTokenLifetimeMinutes"];
        }
    }

    static fromJS(data: any): UpdateOidcApplicationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOidcApplicationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["displayName"] = this.displayName;
        data["clientType"] = this.clientType;
        data["clientSecret"] = this.clientSecret;
        data["consentType"] = this.consentType;
        if (Array.isArray(this.redirectUris)) {
            data["redirectUris"] = [];
            for (let item of this.redirectUris)
                data["redirectUris"].push(item);
        }
        if (Array.isArray(this.postLogoutRedirectUris)) {
            data["postLogoutRedirectUris"] = [];
            for (let item of this.postLogoutRedirectUris)
                data["postLogoutRedirectUris"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["accessTokenLifetimeMinutes"] = this.accessTokenLifetimeMinutes;
        data["refreshTokenLifetimeMinutes"] = this.refreshTokenLifetimeMinutes;
        return data;
    }

    clone(): UpdateOidcApplicationCommand {
        const json = this.toJSON();
        let result = new UpdateOidcApplicationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateOidcApplicationCommand {
    clientId: string;
    displayName?: string | undefined;
    clientType?: string | undefined;
    clientSecret?: string | undefined;
    consentType?: string | undefined;
    redirectUris: string[];
    postLogoutRedirectUris: string[];
    permissions: string[];
    accessTokenLifetimeMinutes?: number | undefined;
    refreshTokenLifetimeMinutes?: number | undefined;
}

export class DashboardStatisticsDto implements IDashboardStatisticsDto {
    totalTenants!: number;
    totalUsers!: number;
    activeUsersLast1Day!: number;
    activeUsersLast7Days!: number;
    activeUsersLast30Days!: number;
    activeUsersTimeline!: TimelineDataPoint[];
    loginsTimeline!: LoginTimelineDataPoint[];

    constructor(data?: IDashboardStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.activeUsersTimeline = [];
            this.loginsTimeline = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTenants = _data["totalTenants"];
            this.totalUsers = _data["totalUsers"];
            this.activeUsersLast1Day = _data["activeUsersLast1Day"];
            this.activeUsersLast7Days = _data["activeUsersLast7Days"];
            this.activeUsersLast30Days = _data["activeUsersLast30Days"];
            if (Array.isArray(_data["activeUsersTimeline"])) {
                this.activeUsersTimeline = [] as any;
                for (let item of _data["activeUsersTimeline"])
                    this.activeUsersTimeline!.push(TimelineDataPoint.fromJS(item));
            }
            if (Array.isArray(_data["loginsTimeline"])) {
                this.loginsTimeline = [] as any;
                for (let item of _data["loginsTimeline"])
                    this.loginsTimeline!.push(LoginTimelineDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTenants"] = this.totalTenants;
        data["totalUsers"] = this.totalUsers;
        data["activeUsersLast1Day"] = this.activeUsersLast1Day;
        data["activeUsersLast7Days"] = this.activeUsersLast7Days;
        data["activeUsersLast30Days"] = this.activeUsersLast30Days;
        if (Array.isArray(this.activeUsersTimeline)) {
            data["activeUsersTimeline"] = [];
            for (let item of this.activeUsersTimeline)
                data["activeUsersTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.loginsTimeline)) {
            data["loginsTimeline"] = [];
            for (let item of this.loginsTimeline)
                data["loginsTimeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): DashboardStatisticsDto {
        const json = this.toJSON();
        let result = new DashboardStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardStatisticsDto {
    totalTenants: number;
    totalUsers: number;
    activeUsersLast1Day: number;
    activeUsersLast7Days: number;
    activeUsersLast30Days: number;
    activeUsersTimeline: TimelineDataPoint[];
    loginsTimeline: LoginTimelineDataPoint[];
}

export class TimelineDataPoint implements ITimelineDataPoint {
    date!: Date;
    count!: number;

    constructor(data?: ITimelineDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TimelineDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["count"] = this.count;
        return data;
    }

    clone(): TimelineDataPoint {
        const json = this.toJSON();
        let result = new TimelineDataPoint();
        result.init(json);
        return result;
    }
}

export interface ITimelineDataPoint {
    date: Date;
    count: number;
}

export class LoginTimelineDataPoint implements ILoginTimelineDataPoint {
    date!: Date;
    successCount!: number;
    failedCount!: number;

    constructor(data?: ILoginTimelineDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
        }
    }

    static fromJS(data: any): LoginTimelineDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new LoginTimelineDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        return data;
    }

    clone(): LoginTimelineDataPoint {
        const json = this.toJSON();
        let result = new LoginTimelineDataPoint();
        result.init(json);
        return result;
    }
}

export interface ILoginTimelineDataPoint {
    date: Date;
    successCount: number;
    failedCount: number;
}

export class TenantDetailsDto implements ITenantDetailsDto {
    id!: string;
    name!: string;
    slug!: string;
    apiUrl!: string;
    backendUrl!: string;

    constructor(data?: ITenantDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.apiUrl = _data["apiUrl"];
            this.backendUrl = _data["backendUrl"];
        }
    }

    static fromJS(data: any): TenantDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["apiUrl"] = this.apiUrl;
        data["backendUrl"] = this.backendUrl;
        return data;
    }

    clone(): TenantDetailsDto {
        const json = this.toJSON();
        let result = new TenantDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDetailsDto {
    id: string;
    name: string;
    slug: string;
    apiUrl: string;
    backendUrl: string;
}

export class CreateTenantCommand implements ICreateTenantCommand {
    name!: string;
    slug!: string;
    tenantImageTag?: string | undefined;
    postgresSingleInstance!: boolean;

    constructor(data?: ICreateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.tenantImageTag = _data["tenantImageTag"];
            this.postgresSingleInstance = _data["postgresSingleInstance"];
        }
    }

    static fromJS(data: any): CreateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["tenantImageTag"] = this.tenantImageTag;
        data["postgresSingleInstance"] = this.postgresSingleInstance;
        return data;
    }

    clone(): CreateTenantCommand {
        const json = this.toJSON();
        let result = new CreateTenantCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantCommand {
    name: string;
    slug: string;
    tenantImageTag?: string | undefined;
    postgresSingleInstance: boolean;
}

export class UpdateTenantCommand implements IUpdateTenantCommand {
    tenantId!: string;
    name!: string;
    apiUrl!: string;
    backendUrl!: string;
    postgresSingleInstance?: boolean | undefined;

    constructor(data?: IUpdateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.apiUrl = _data["apiUrl"];
            this.backendUrl = _data["backendUrl"];
            this.postgresSingleInstance = _data["postgresSingleInstance"];
        }
    }

    static fromJS(data: any): UpdateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["apiUrl"] = this.apiUrl;
        data["backendUrl"] = this.backendUrl;
        data["postgresSingleInstance"] = this.postgresSingleInstance;
        return data;
    }

    clone(): UpdateTenantCommand {
        const json = this.toJSON();
        let result = new UpdateTenantCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantCommand {
    tenantId: string;
    name: string;
    apiUrl: string;
    backendUrl: string;
    postgresSingleInstance?: boolean | undefined;
}

export class RollbackTenantCommand implements IRollbackTenantCommand {
    tenantId!: string;
    recoveryFolderName?: string | undefined;
    pointInTime?: Date | undefined;

    constructor(data?: IRollbackTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.recoveryFolderName = _data["recoveryFolderName"];
            this.pointInTime = _data["pointInTime"] ? new Date(_data["pointInTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RollbackTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RollbackTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["recoveryFolderName"] = this.recoveryFolderName;
        data["pointInTime"] = this.pointInTime ? this.pointInTime.toISOString() : undefined as any;
        return data;
    }

    clone(): RollbackTenantCommand {
        const json = this.toJSON();
        let result = new RollbackTenantCommand();
        result.init(json);
        return result;
    }
}

export interface IRollbackTenantCommand {
    tenantId: string;
    recoveryFolderName?: string | undefined;
    pointInTime?: Date | undefined;
}

export class PaginatedListOfUserDto implements IPaginatedListOfUserDto {
    items!: UserDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfUserDto {
        const json = this.toJSON();
        let result = new PaginatedListOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfUserDto {
    items: UserDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class UserDetailsWithTenantsDto extends UserDetailsDto implements IUserDetailsWithTenantsDto {
    tenants!: TenantDto[];

    constructor(data?: IUserDetailsWithTenantsDto) {
        super(data);
        if (!data) {
            this.tenants = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UserDetailsWithTenantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsWithTenantsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): UserDetailsWithTenantsDto {
        const json = this.toJSON();
        let result = new UserDetailsWithTenantsDto();
        result.init(json);
        return result;
    }
}

export interface IUserDetailsWithTenantsDto extends IUserDetailsDto {
    tenants: TenantDto[];
}

export class CreateUserCommand implements ICreateUserCommand {
    email!: string;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): CreateUserCommand {
        const json = this.toJSON();
        let result = new CreateUserCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCommand {
    email: string;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    userId!: string;
    email!: string;
    phoneNumber!: string;
    honorificPrefix?: string | undefined;
    givenName?: string | undefined;
    additionalName?: string | undefined;
    familyName?: string | undefined;
    honorificSuffix?: string | undefined;
    streetAddress?: string | undefined;
    addressLevel1?: string | undefined;
    addressLevel2?: string | undefined;
    addressLevel3?: string | undefined;
    addressLevel4?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    language?: string | undefined;
    birthDay!: Date;
    sex?: string | undefined;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.honorificPrefix = _data["honorificPrefix"];
            this.givenName = _data["givenName"];
            this.additionalName = _data["additionalName"];
            this.familyName = _data["familyName"];
            this.honorificSuffix = _data["honorificSuffix"];
            this.streetAddress = _data["streetAddress"];
            this.addressLevel1 = _data["addressLevel1"];
            this.addressLevel2 = _data["addressLevel2"];
            this.addressLevel3 = _data["addressLevel3"];
            this.addressLevel4 = _data["addressLevel4"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.language = _data["language"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : undefined as any;
            this.sex = _data["sex"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["honorificPrefix"] = this.honorificPrefix;
        data["givenName"] = this.givenName;
        data["additionalName"] = this.additionalName;
        data["familyName"] = this.familyName;
        data["honorificSuffix"] = this.honorificSuffix;
        data["streetAddress"] = this.streetAddress;
        data["addressLevel1"] = this.addressLevel1;
        data["addressLevel2"] = this.addressLevel2;
        data["addressLevel3"] = this.addressLevel3;
        data["addressLevel4"] = this.addressLevel4;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["language"] = this.language;
        data["birthDay"] = this.birthDay ? formatDate(this.birthDay) : undefined as any;
        data["sex"] = this.sex;
        return data;
    }

    clone(): UpdateUserCommand {
        const json = this.toJSON();
        let result = new UpdateUserCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCommand {
    userId: string;
    email: string;
    phoneNumber: string;
    honorificPrefix?: string | undefined;
    givenName?: string | undefined;
    additionalName?: string | undefined;
    familyName?: string | undefined;
    honorificSuffix?: string | undefined;
    streetAddress?: string | undefined;
    addressLevel1?: string | undefined;
    addressLevel2?: string | undefined;
    addressLevel3?: string | undefined;
    addressLevel4?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    language?: string | undefined;
    birthDay: Date;
    sex?: string | undefined;
}

export class UpdateUserPasswordCommand implements IUpdateUserPasswordCommand {
    userId!: string;
    password!: string;

    constructor(data?: IUpdateUserPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UpdateUserPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    }

    clone(): UpdateUserPasswordCommand {
        const json = this.toJSON();
        let result = new UpdateUserPasswordCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserPasswordCommand {
    userId: string;
    password: string;
}

export class UpdateUserAccountStatusCommand implements IUpdateUserAccountStatusCommand {
    userId!: string;
    emailConfirmed!: boolean;
    phoneNumberConfirmed!: boolean;

    constructor(data?: IUpdateUserAccountStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
        }
    }

    static fromJS(data: any): UpdateUserAccountStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserAccountStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        return data;
    }

    clone(): UpdateUserAccountStatusCommand {
        const json = this.toJSON();
        let result = new UpdateUserAccountStatusCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserAccountStatusCommand {
    userId: string;
    emailConfirmed: boolean;
    phoneNumberConfirmed: boolean;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}